import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

// Marketing / platform pages
import SaasLanding from "./pages/SaasLanding";
import Signup from "./pages/Signup";
import SignupSuccess from "./pages/SignupSuccess";
import MyCafes from "./pages/MyCafes";
import OwnerHome from "./pages/OwnerHome";
import AuthReturn from "./pages/AuthReturn";
import SuperAdmin from "./pages/SuperAdmin";
import Pitch from "./pages/Pitch";

// Tenant-scoped pages
import TenantScope from "./pages/TenantScope";
import Landing from "./pages/Landing";
import Menu from "./pages/Menu";
import Unavailable from "./pages/Unavailable";
import UniversalWallet from "./pages/UniversalWallet";
import Cart from "./pages/Cart";
import Confirmation from "./pages/Confirmation";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Staff from "./pages/Staff";
import Rewards from "./pages/Rewards";
import Wallet from "./pages/Wallet";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminHome from "./pages/admin/AdminHome";
import AdminMenu from "./pages/admin/AdminMenu";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminCustomers from "./pages/admin/AdminCustomers";
import AdminReports from "./pages/admin/AdminReports";
import AdminCatalog from "./pages/admin/AdminCatalog";
import AdminSettings from "./pages/admin/AdminSettings";
import RequireAdmin from "./pages/admin/RequireAdmin";

// PWA
import InstallPrompt from "./components/InstallPrompt";
import OfflineBanner from "./components/OfflineBanner";
import UpdateToast from "./components/UpdateToast";
import { registerServiceWorker } from "./lib/pwa";

// Register the service worker once at module load. Guarded to only run
// under https/localhost (see pwa.js).
registerServiceWorker();

function App() {
    return (
        <div className="App">
            <OfflineBanner />
            <InstallPrompt />
            <UpdateToast />
            <Toaster
                position="top-center"
                toastOptions={{
                    style: {
                        background: "#2C1A12",
                        color: "#F9F6F0",
                        border: "1px solid #E8DCCB",
                        borderRadius: "9999px",
                        fontFamily: "Manrope, sans-serif",
                    },
                }}
            />
            <BrowserRouter>
                <Routes>
                    {/* Marketing + platform */}
                    <Route path="/" element={<SaasLanding />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/signup/success/:slug" element={<SignupSuccess />} />
                    <Route path="/me" element={<MyCafes />} />
                    <Route path="/wallet" element={<UniversalWallet />} />
                    <Route path="/owner" element={<OwnerHome />} />
                    <Route path="/auth/return" element={<AuthReturn />} />
                    <Route path="/super-admin" element={<SuperAdmin />} />
                    <Route path="/pitch" element={<Pitch />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/privacy" element={<Privacy />} />

                    {/* Tenant-scoped */}
                    <Route path="/:slug" element={<TenantScope />}>
                        <Route index element={<Landing />} />
                        <Route path="menu" element={<Menu />} />
                        <Route path="unavailable" element={<Unavailable />} />
                        <Route path="cart" element={<Cart />} />
                        <Route path="confirmation/:orderId" element={<Confirmation />} />
                        <Route path="payment/success" element={<PaymentSuccess />} />
                        <Route path="payment/cancel" element={<PaymentCancel />} />
                        <Route path="staff" element={<Staff />} />
                        <Route path="rewards" element={<Rewards />} />
                        <Route path="wallet" element={<Wallet />} />

                        <Route path="admin" element={<AdminLogin />} />
                        <Route
                            path="admin/dashboard"
                            element={
                                <RequireAdmin>
                                    <AdminLayout />
                                </RequireAdmin>
                            }
                        >
                            <Route index element={<AdminHome />} />
                            <Route path="menu" element={<AdminMenu />} />
                            <Route path="catalog" element={<AdminCatalog />} />
                            <Route path="orders" element={<AdminOrders />} />
                            <Route path="customers" element={<AdminCustomers />} />
                            <Route path="reports" element={<AdminReports />} />
                            <Route path="settings" element={<AdminSettings />} />
                        </Route>
                    </Route>

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
